import { useNode } from '@craftjs/core';
import {
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    Switch,
    TextField,
} from '@mui/material';
import { SettingCard } from '@/components';

const InputSettings = () => {
    const {
        actions: { setProp },
        props,
    } = useNode((node) => ({
        props: node.data.props,
    }));

    return (
        <Stack spacing={2}>
            <SettingCard title="Formato">
                <Stack spacing={2}>
                    {/* Label */}
                    <TextField
                        label="Etiqueta"
                        size="small"
                        value={props.label || ''}
                        onChange={(e) =>
                            setProp((props: any) => {
                                props.label = e.target.value;
                            })
                        }
                    />

                    {/* Helper Text */}
                    <TextField
                        label="Texto de ayuda"
                        size="small"
                        value={props.helperText || ''}
                        onChange={(e) =>
                            setProp((props: any) => {
                                props.helperText = e.target.value;
                            })
                        }
                    />

                    {/* Variant */}
                    <FormControl fullWidth size="small">
                        <InputLabel>Variante</InputLabel>
                        <Select
                            label="Variante"
                            value={props.variant || 'outlined'}
                            onChange={(e) =>
                                setProp((props: any) => {
                                    props.variant = e.target.value;
                                })
                            }
                        >
                            <MenuItem value="outlined">Outlined</MenuItem>
                            <MenuItem value="filled">Filled</MenuItem>
                            <MenuItem value="standard">Standard</MenuItem>
                        </Select>
                    </FormControl>

                    {/* Size */}
                    <FormControl fullWidth size="small">
                        <InputLabel>Tamaño</InputLabel>
                        <Select
                            label="Tamaño"
                            value={props.size || 'medium'}
                            onChange={(e) =>
                                setProp((props: any) => {
                                    props.size = e.target.value;
                                })
                            }
                        >
                            <MenuItem value="small">Pequeño</MenuItem>
                            <MenuItem value="medium">Mediano</MenuItem>
                        </Select>
                    </FormControl>


                    {/* Full Width */}
                    <FormControlLabel
                        control={
                            <Switch
                                checked={props.fullWidth || false}
                                onChange={(e) =>
                                    setProp((props: any) => {
                                        props.fullWidth = e.target.checked;
                                    })
                                }
                            />
                        }
                        label="Ancho completo"
                    />

                    {/* Required */}
                    <FormControlLabel
                        control={
                            <Switch
                                checked={props.required || false}
                                onChange={(e) =>
                                    setProp((props: any) => {
                                        props.required = e.target.checked;
                                    })
                                }
                            />
                        }
                        label="Requerido"
                    />
                </Stack>
            </SettingCard>
        </Stack>
    );
};

export default InputSettings;
